import React, { useMemo, useState } from 'react';
import { Box, List, ListItemButton, Paper, TextField, Typography } from '@mui/material';
import { AirLineLogo } from 'features/flightsExplorer/components/AirlineLogo';
import { CarrierReferenceItem } from '../../helpers/carrierReference';

interface CarrierSelectorListProps {
	carriers: CarrierReferenceItem[];
	selectedCode: string | null;
	onSelect: (code: string) => void;
}

export const CarrierSelectorList = ({ carriers, selectedCode, onSelect }: CarrierSelectorListProps): JSX.Element => {
	const [search, setSearch] = useState('');

	const filtered = useMemo(() => {
		const q = search.trim().toLowerCase();
		if (!q) return carriers;
		return carriers.filter((c) => c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q));
	}, [carriers, search]);

	return (
		<Paper variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 2 }}>
			<Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
				<Typography variant="subtitle2" fontWeight="bold" gutterBottom>
					Aerolínea
				</Typography>
				<TextField
					size="small"
					fullWidth
					placeholder="Buscar por nombre o código…"
					value={search}
					onChange={(e) => setSearch(e.target.value)}
				/>
			</Box>
			<List dense sx={{ overflow: 'auto', flex: 1, maxHeight: { xs: 280, md: 'calc(100vh - 220px)' }, py: 0 }}>
				{filtered.length === 0 && (
					<Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
						Sin resultados
					</Typography>
				)}
				{filtered.map((carrier) => (
					<ListItemButton
						key={carrier.code}
						selected={selectedCode === carrier.code}
						onClick={() => onSelect(carrier.code)}
						sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 1.25 }}
					>
						<AirLineLogo code={carrier.code} name={carrier.name} showName />
						<Typography variant="caption" color="text.secondary" sx={{ ml: '32px' }}>
							{carrier.code}
						</Typography>
					</ListItemButton>
				))}
			</List>
		</Paper>
	);
};
